import React, { MouseEvent } from 'react';
import { Dialog } from '../../../../../../components/Dialog';
import { Images } from '@ansvar-sakerhet/ui/src/assets/images';
import { useDeletePersonnel } from '../../../../../../traits/api/workRegisters/useDeletePersonnel';
import { useControl } from '../../../../components/ControlLayout';
import { S } from './DeletePersonnelDialog.styles';

type Props = {
  personnelId: string;
  onClose: () => void;
};

export const DeletePersonnelDialog: React.FC<Props> = (props) => {
  const { data } = useControl();
  const deletePersonnel = useDeletePersonnel(data.controlId, {
    onDeletePersonnelSuccess: props.onClose,
  });

  const onCancel = (
    e: MouseEvent<HTMLButtonElement, globalThis.MouseEvent>
  ) => {
    e.stopPropagation();
    props.onClose();
  };

  return (
    <Dialog.Base onClose={props.onClose}>
      <img src={Images.Delete} width={295} height={215} />

      <Dialog.Title>
        <S.H5>Är du säker på att du vill radera personen?</S.H5>
      </Dialog.Title>

      <Dialog.Description>
        <S.H6>Personen och tillhörande persondata kommer inte kunna återställas.</S.H6>
      </Dialog.Description>

      <S.ButtonContainer>
        <Dialog.CancelButton>
          <S.Button $outlined onClick={onCancel}>
            Avbryt
          </S.Button>
        </Dialog.CancelButton>

        <Dialog.Button>
          <S.Button
            disabled={deletePersonnel.isLoading}
            onClick={(e) => {
              e.stopPropagation();
              deletePersonnel.mutate(props.personnelId);
            }}
          >
            Ja, radera
          </S.Button>
        </Dialog.Button>
      </S.ButtonContainer>
    </Dialog.Base>
  );
};
